import React, { useState } from "react";
import { Headset, Loader2 } from "lucide-react";
import { agentApi } from "@/lib/api";
import { toast } from "sonner";

export default function AgentLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await agentApi.post("/api/agent/login", { email, password });
            localStorage.setItem("orchid_agent_token", data.access_token);
            localStorage.setItem("orchid_agent_name", data.agent?.name || "Agent");
            window.location.assign("/agent");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-ivory px-4">
            <div className="w-full max-w-md">
                <div className="flex flex-col items-center mb-8">
                    <div className="w-14 h-14 rounded-2xl bg-orchid-700 text-white flex items-center justify-center mb-3">
                        <Headset size={26} />
                    </div>
                    <h1 className="font-heading text-3xl text-orchid-700">Orchid Live Desk</h1>
                    <p className="text-sm text-stone-500 mt-1">Sign in to respond to guests</p>
                </div>
                <form
                    onSubmit={submit}
                    className="bg-white border border-stone-200 rounded-2xl p-7 shadow-card space-y-4"
                    data-testid="agent-login-form"
                >
                    <div>
                        <label className="text-[11px] uppercase tracking-wider text-stone-500 block mb-1.5">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="agent-login-email"
                            className="w-full px-3.5 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:border-orchid-700 focus:ring-2 focus:ring-orchid-700/15"
                        />
                    </div>
                    <div>
                        <label className="text-[11px] uppercase tracking-wider text-stone-500 block mb-1.5">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="agent-login-password"
                            className="w-full px-3.5 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:border-orchid-700 focus:ring-2 focus:ring-orchid-700/15"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="agent-login-submit"
                        className="w-full bg-orchid-700 hover:bg-orchid-600 text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
                    >
                        {loading && <Loader2 size={15} className="animate-spin" />}
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
